// this function needs to be changes when usage of clickAction is completely removed from all queries
export function objectArrayToArrayConversion(content) {
  return Object.values(content.map(function (content) {
    return content.text;
  }));
}